export default __webpack_public_path__ + "static/media/Vector.66df8b96.svg";